import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { DomainPrebidStack } from '../../types/domainPrebidStack'
import { DomainPrebidStackDTO } from '../types/domainPrebidStackDTO'

export const domainPrebidStackFromDTO = (from: DomainPrebidStackDTO): DomainPrebidStack =>
  mapDTO<DomainPrebidStackDTO, DomainPrebidStack>({ from }).transform(
    (domainPrebidStackDTO: DomainPrebidStackDTO): DomainPrebidStack => {
      const {
        allowActivitiesData,
        createdAt,
        domainAmazonEnabled,
        prebidCustomConfig,
        syncDelay,
        syncDelayEnabled,
        syncsPerBidder,
        syncsPerBidderEnabled,
        updatedAt,
        ...rest
      } = domainPrebidStackDTO

      return {
        ...rest,
        allowActivitiesData: allowActivitiesData ?? '',
        createdAt: new Date(createdAt),
        domainAmazonEnabled: domainAmazonEnabled ?? undefined,
        prebidCustomConfig: JSON.stringify(prebidCustomConfig, null, JSON_SPACE),
        syncDelay: syncDelay ?? undefined,
        syncDelayEnabled: Boolean(syncDelayEnabled),
        syncsPerBidder: syncsPerBidder ?? undefined,
        syncsPerBidderEnabled: Boolean(syncsPerBidderEnabled),
        updatedAt: new Date(updatedAt),
      }
    },
  )
